import { ITableUI } from "../../TableTemplate/tableTemplate";
import { IStepCompetitionConfigTableReport } from "../../../Interfaces/stepInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";
import { useEffect } from "react";
import { useAppSelector } from "../../../App/hooks";
import { Additional } from "./Additional";

const TableUI: React.FC<ITableUI<IStepCompetitionConfigTableReport>> = ({
  reports,
  onAction,
  onTableRowClick,
}: ITableUI<IStepCompetitionConfigTableReport>) => {
  const flag = useAppSelector((store) => store.step).competitionConfigTableFlag;

  useEffect(() => {
    if (flag && onAction) onAction();
  }, [flag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      onTableRowClick={onTableRowClick}
      AdditionalBody={Additional}
    />
  );
};

export default TableUI;
